import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Avatar, Tooltip } from 'antd';
import { getDirection } from '../../../../helpers';
import { useStore } from '../../../../store/rootStore';
import placeholderAvatar from '../../../../assets/avatars/placeholder-avatar.png';
import styles from './AccountSection.module.scss';
import iconStyles from '../ClickableIcon/ClickableIcon.module.scss';
const AccountSection = () => {
    var _a, _b;
    const { loginStore, navigation } = useStore();
    const { t } = useTranslation();
    const userName = (_b = (_a = loginStore.userDetails) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : '';
    return (React.createElement("div", { className: styles.accountSection },
        React.createElement("div", { className: styles.user },
            React.createElement(Tooltip, { placement: getDirection() === 'rtl' ? 'left' : 'right', title: t('userSettings') },
                React.createElement("button", { type: "button", className: classnames(iconStyles.button, {
                        [iconStyles.buttonColorSelect]: navigation.sectionOpen.userSettings,
                    }), "aria-label": t('userSettings'), "aria-expanded": !!navigation.sectionOpen.userSettings, onClick: () => navigation.setWorkspaceOverlay(navigation.sectionOpen.userSettings ? undefined : 'userSettings') },
                    React.createElement(Avatar, { alt: userName, src: placeholderAvatar, size: 32 }))),
            React.createElement("span", { className: styles.name, title: userName }, userName))));
};
export default observer(AccountSection);
